/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { bankDetailsPostRequestSchema } from './bankDetailsPostRequestSchema.ts';
import { bankDetailsPostResponseSchema } from './bankDetailsPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postBankDetails200Schema = z.lazy(() => bankDetailsPostResponseSchema);

/**
 * @description 505 response
 */
export const postBankDetails505Schema = z.any();

export const postBankDetailsMutationRequestSchema = z.lazy(() => bankDetailsPostRequestSchema);

export const postBankDetailsMutationResponseSchema = z.lazy(() => postBankDetails200Schema);
